import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from 'src/app/globals';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { LoaderService } from 'src/app/services/loader.service';
import { MustMatch } from 'src/app/util/must-match.validator';
import { RegUser } from '../basic-reg/RegUser';
import { timer } from 'rxjs';
import { takeWhile, tap } from 'rxjs/operators';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { CommonUtil } from 'src/app/util/CommonUtil';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.component.html',
  styleUrls: ['./forgot-pass.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    IonicModule,
    FooterComponent,
    HeaderComponent,
    NgxIntlTelInputModule
  ]
})
export class ForgotPassComponent implements OnInit {

  separateDialCode = false;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.India];

  requestPath: any;

  heading = "Reset Password";
  subheading = "Recover Your Account";

  stepFirst: boolean = true;
  stepSecond: boolean = false;
  stepThird: boolean = false;
  stepFour: boolean = false;

  mobileNo: any;
  phoneNumberAll: any;
  fpForm: FormGroup = new FormGroup({});
  fpSubmitted: boolean = false;
  errorMessage: string | null = null;

  otp: any;
  otpForm: FormGroup = new FormGroup({});
  otpSubmitted: boolean = false;
  emailOtp: any;
  emailOtpForm: FormGroup = new FormGroup({});
  emailOtpSubmitted: boolean = false;
  activeResendLink: boolean = false;
  counter: number = 120;
  time: any;

  cpUser = new RegUser();
  cpForm: FormGroup = new FormGroup({});
  cpSubmitted: boolean = false;

  passwordVisible: boolean = false;
  confirmPasswordVisible: boolean = false;

  localToken: any;
  user: RegUser = new RegUser();
  LoggedIn: boolean = false;
  selectedMobilNo: any;
  email: any;
  hiddinEmail: any;
  registeredEmail: any;

  formattedPhoneNo:any;
  formattedEmail:any;

  constructor(public global: Globals
    , public authService: AuthServiceService
    , public formBuilder: FormBuilder
    , public router: Router
    , private loader: LoaderService
    , private cdr: ChangeDetectorRef) {
    this.requestPath = this.global.requestPath;
  }

  ngOnInit() {
    this.fpForm = this.formBuilder.group({
      phoneNumber: ['', [Validators.required]]
    });

    this.otpForm = this.formBuilder.group({
      otp: ['', [Validators.required]]
    });

    this.emailOtpForm = this.formBuilder.group({
      emailOtp: ['', [Validators.required]]
    });

    this.cpForm = this.formBuilder.group({
      userPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
    }, {
      validator: MustMatch('userPassword', 'confirmPassword')
    });

    this.counter = 120;
    this.startCountdown();
  }

  ionViewDidEnter() {
    this.onReset();
    this.user = this.authService.getLoggedInUser();
    if (!this.global.isEmpty(this.user)) {
      this.user.imageUrl = this.authService.getProfilePicture() as string;
    }
  }

  ionViewWillEnter() {
    this.LoggedIn = this.authService.isLoggedIn();
    if (!this.global.isEmpty(this.user)) {
      this.user.imageUrl = this.authService.getProfilePicture() as string;
    }
  }

  onReset = () => {
    this.heading = "Reset password";
    this.formattedPhoneNo = '';
    this.formattedEmail = '';

    this.fpForm.reset();
    this.otpForm.reset();
    this.cpForm.reset();

    this.mobileNo = null;
    this.phoneNumberAll = null;
    this.email = null;
    this.hiddinEmail = null;
    this.registeredEmail = null;
    this.otp = null;
    this.emailOtp = null;
    this.cpUser = new RegUser();

    this.fpSubmitted = false;
    this.otpSubmitted = false;
    this.cpSubmitted = false;
    this.emailOtpSubmitted = false;

    this.stepFirst = true;
    this.stepSecond = false;
    this.stepThird = false;
    this.stepFour = false;

    this.errorMessage = null;
    this.resetPhoneNumber();
  }

  resetPhoneNumber() {
    this.cpUser.phoneDialCode = "1";
    this.cpUser.phoneCountryShortName = "us";
    this.selectedMobilNo = null;
  }

  startCountdown() {

    timer(0, 1000)
      .pipe(
        takeWhile(() => this.counter > 0),
        tap(() => this.counter--)
      )
      .subscribe(() => {
        const minutes = Math.floor(this.counter / 60);
        const seconds = this.counter - minutes * 60;

        this.time = (minutes.toString()).padStart(2, '0') + ':' + (seconds.toString()).padStart(2, '0');

        if (this.counter < 1) {
          this.activeResendLink = true;
        }
        this.cdr.detectChanges();
      });
  }

  resendMobileOTP() {
    this.loader.show("Sending verification code...");
    this.mobileNo = this.phoneNumberAll?.e164Number.replace(this.phoneNumberAll.dialCode, "");
    this.authService.getNoSecure('ns/common/user?' + this.requestPath + '=sendEmailPhoneOtp&phoneNumber=' + this.mobileNo)
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);
        if ((res as any).success) {
          // console.log("OTP has been resend");

          this.counter = 120;
          this.activeResendLink = false;
          this.startCountdown();
          // console.log((res as any).description);
        } else {
          this.errorMessage = (res as any).message
        }
        this.cdr.detectChanges();
      }, error => {
        this.loader.hide();
        this.errorMessage = "Error occured, please try again.";
        this.cdr.detectChanges();
      });
  }

  resendEmailOTP() {
    this.loader.show("Sending verification code...");
    this.authService.getNoSecure('ns/common/user?' + this.requestPath + '=sendEmailPhoneOtp&email=' + this.email)
      .subscribe((res) => {
        this.loader.hide();
        // console.log(res);
        if ((res as any).success) {
          // console.log("OTP has been resend");

          this.counter = 120;
          this.activeResendLink = false;
          this.startCountdown();
          // console.log((res as any).description);
        } else {
          this.errorMessage = (res as any).message;
          
        }
        this.cdr.detectChanges();
      }, error => {
        this.loader.hide();
        this.errorMessage = "Error occured, please try again.";
        this.cdr.detectChanges();
      });
  }

  public sendMobileOTP() {
    this.fpSubmitted = true;
    this.errorMessage = null;

    // stop here if form is invalid
    if (this.fpForm.invalid) {
      // console.log("Invalid: " + this.fpForm.value);
      return;
    }
    this.mobileNo = this.phoneNumberAll?.e164Number.replace(this.phoneNumberAll.dialCode, "");;
    this.loader.show("Sending verification code...");
    this.authService.getNoSecure('ns/common/user?' + this.requestPath + '=sendEmailPhoneOtp&phoneNumber=' + this.mobileNo)
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);
        if ((res as any).success) {
          this.formattedPhoneNo = CommonUtil.formatPhone(this.mobileNo);
          this.heading = "Enter Mobile verification Code";
          this.subheading = "Check your registered mobile for Verification Code";
          this.stepFirst = false;
          this.stepSecond = true;

          this.counter = 120;
          this.activeResendLink = false;
          // console.log((res as any).description);
        } else {
          this.errorMessage = (res as any).message;
        }
        this.cdr.detectChanges();
      }, error => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  validateMobileOTP = () => {

    this.otpSubmitted = true;
    this.errorMessage = '';

    if (this.otpForm.invalid) {
      // console.log("Invalid form");
      return;
    }
    
    this.mobileNo = this.phoneNumberAll?.e164Number.replace(this.phoneNumberAll.dialCode, "");;

    this.loader.show("Verifying...");
    this.authService.getNoSecure('ns/common/user?' + this.requestPath + '=verifyMobileOTP&mobileNumber=' + this.mobileNo + '&otp=' + this.otp.trim() + "&isRecoverAccount=true&sendEmail=false")
      .subscribe((res:any) => {
        this.loader.hide();
        // console.log(res);
        if ((res as any).success) {
          (res as any).data = this.global.decryptDefault((res as any).data);
          // console.log((res as any).data);
          this.email = (res as any).data?.hiddinEmail != undefined ? (res as any).data?.hiddinEmail : (res as any).data?.email;
          this.registeredEmail = (res as any).data?.email;
          this.hiddinEmail = (res as any).data?.hiddinEmail;
          this.sendEmailOTP();
          this.stepFirst = false;
          this.stepSecond = false;
          this.stepThird = true;
        } else {
          this.errorMessage = (res as any).message;
        }
        this.cdr.detectChanges();
      }, error => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });

  }

  public sendEmailOTP() {

    if (this.global.isEmpty(this.email)) {
      this.errorMessage = "Email not found";
      return;
    }

    this.loader.show("Sending verification code...");
    this.authService.getNoSecure('ns/common/user?' + this.requestPath + '=sendEmailPhoneOtp&email=' + this.email)
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);
        if (res && res.success) {
          this.heading = "Enter Email verification Code";
          this.subheading = "Check your registered email for Verification Code";

          this.formattedEmail = CommonUtil.formatEmail(this.registeredEmail);
          if(this.hiddinEmail){
            this.formattedEmail += " and " + CommonUtil.formatEmail(this.hiddinEmail);
          }

          this.counter = 120;
          this.activeResendLink = false;
          // console.log(res.description);
        } else {
          this.errorMessage = res?.message;
        }
        this.cdr.detectChanges();
      }, error => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  validateEmailOTP = () => {

    this.emailOtpSubmitted = true;
    this.errorMessage = '';

    if (this.otpForm.invalid) {
      // console.log("Invalid form");
      return;
    }

    if (this.global.isEmpty(this.email)) {
      this.errorMessage = "Email not found";
      return;
    }

    this.loader.show("Verifying...");
    this.authService.getNoSecure('ns/common/user?' + this.requestPath + '=verifyEmailOTP&email=' + this.email + '&otp=' + this.emailOtp.trim() + '&tokenRequired=true')
      .subscribe((res) => {
        this.loader.hide();
        // console.log(res);
        if ((res as any).success) {
          (res as any).data = this.global.decryptDefault((res as any).data);
          this.localToken = JSON.stringify((res as any).data.access_token);
          this.heading = "Create New Password";
          this.subheading = "set your new Password";
          this.stepFirst = false;
          this.stepSecond = false;
          this.stepThird = false;
          this.stepFour = true;
        } else {
          this.errorMessage = (res as any).message;
        }
        this.cdr.detectChanges();
      }, error => {
        this.loader.hide();
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });

  }

  createNewPassword = () => {

    this.cpSubmitted = true;
    this.errorMessage = '';

    if (this.cpForm.invalid) {
      // console.log("Invalid form");
      return;
    }

    this.cpUser.password = window.btoa(this.cpUser.userPassword ?? '');
    this.mobileNo = this.phoneNumberAll?.e164Number.replace(this.phoneNumberAll?.dialCode, "");;
 
    this.cpUser.phoneNumber = this.mobileNo;

    this.loader.show("Please wait...");
    this.authService.postEcryptWithToken('common/user?' + this.requestPath + '=createNewPassword', this.cpUser, this.localToken)
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);
        if (res.success) {
          this.heading = "Password Reset Successfully";
          this.subheading = "Your password has been set successfully."
          this.stepFirst = false;
          this.stepSecond = false;
          this.stepThird = false;
          this.stepFour = false;
        } else {
          this.errorMessage = res.message;
        }
        this.cdr.detectChanges();
      }, (error: any) => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  // Phone number with country code field
  onCountryChange = (event: any) => {
    this.cpUser.phoneDialCode = this.phoneNumberAll?.dialCode;
    this.cpUser.phoneCountryShortName = this.phoneNumberAll?.countryCode;
  }


  togglePassword(id: string) {
    const password = document.querySelector('#' + id);
    if (password) {
      const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
      password.setAttribute('type', type);
    }

    if (id === 'resetPwd') {
      this.passwordVisible = !this.passwordVisible;
    }

    if (id === 'confirmResetPassword') {
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
    }




  }

}
